import { requestSearchMembersForOffice } from "@/state/offices/OfficesEffects";
import { Member } from "@/type/core/offices/offices.types";
import { toastError } from "@/utils/helpers/toast-helper";
import useSignaturePositioning from "@/utils/hooks/useSignaturePositioning";
import PageLayout from "@components/core/layouts/PageLayout";
import Positioning from "@components/core/subComponents/Positioning";
import { ROUTES } from "@routes/Routes";
import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SignaturePositioningScreen: FunctionComponent = () => {
  const { t } = useTranslation();

  const {
    transactionType,
    files,
    signatories,
    signatures,
    signatureRequirementMode,
    setSignatureRequirementMode,
    manualPositioning,
    setManualPositioning,
    officeId,
  } = useSignaturePositioning();
  const [members, setMembers] = useState<Member[]>([]);
  // const [contacts, setContacts] = useState<Contact[]>([]);

  useEffect(() => {
    if (officeId) {
      // void requestSearchContactsForOffice({ id: transactionForm?.officeId });
      void requestSearchMembersForOffice({ id: officeId });
    }
  }, [officeId]);

  useEffect(() => {
    return requestSearchMembersForOffice.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setMembers(result.data.contacts || []);
      } else {
        toastError(t("error.retrieveMembers"));
      }
    });
  });

  return (
    <PageLayout
      container
      returnRoute={ROUTES.extranet.home.generate()}
      hideDropdown
    >
      <Positioning
        transactionType={transactionType}
        files={files}
        signatories={signatories}
        signatures={signatures}
        signatureRequirementMode={signatureRequirementMode}
        setSignatureRequirementMode={setSignatureRequirementMode}
        manualPositioning={manualPositioning}
        setManualPositioning={setManualPositioning}
        members={members}
        officeId={officeId ?? ""}
      />
    </PageLayout>
  );
};

export default SignaturePositioningScreen;
